import gql from 'graphql-tag';

export default gql`
mutation changeAppLinks(
        $uuid: String!,
        $linkWeb: String,
        $linkYoutube: String,
        $linkFacebook: String,
        $linkInstagram: String,
        $linkTwitter: String
        ) {
    updateApps(input: {
        uuid: $uuid,
        linkWeb: $linkWeb,
        linkYoutube: $linkYoutube,
        linkFacebook: $linkFacebook,
        linkInstagram: $linkInstagram,
        linkTwitter: $linkTwitter
    }) {
        uuid
    }
}
`;
